import { useEffect, useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'
import { getUserAssessmentId } from '@app/firebase/api'
import { setUserAssessmentId, setUserId } from '@app/storage'
import { GROUP_REVIEW_USER } from '@app/constants'
import { getUseSchoolYear } from '@app/flags'
import { getUserAssessments } from '@app/firebase/api/firestore/userAssessments'

export const useUserAssessmentIdSetup = () => {
  const [searchParams] = useSearchParams()

  const setupUser = useCallback(async(userId: string, assessmentId: string, schoolYear: string, attempt: number) => {
    setUserId(userId)
    const userAssessmentId = await(async() => {
      if( getUseSchoolYear() ) {
        return getUserAssessmentId(userId, assessmentId, schoolYear, attempt)
      }
      // We don't care about the school year, so find the last one
      const assessments = (await getUserAssessments(userId, assessmentId)).filter(doc => doc.deleted !== true).sort((a,b) => {
        return Number(b.createdTimestamp)-Number(a.createdTimestamp)
      })
      if( assessments.length > 0 ) {
        return assessments[0].id
      }
      // Fall back is to create one
      return getUserAssessmentId(userId, assessmentId, schoolYear, attempt)
    })()
    if( userAssessmentId ) {
      setUserAssessmentId(userAssessmentId)
    }
  }, [])

  useEffect(() => {
    if (!searchParams) {
      return
    }

    const userId = searchParams.get('userId') ?? GROUP_REVIEW_USER
    const assessmentId = searchParams.get('id')
    const schoolYear = searchParams.get('schoolYear')
    const attempt = Number(searchParams.get('attempt'))

    if (!!(assessmentId && schoolYear && attempt)) {
      setupUser(userId, assessmentId, schoolYear, attempt)
    }
  }, [searchParams, setupUser])
}
